

import React from 'react';
import weaponsImg from './Logos/Assets/Weapons.png';
import './Styles/Subsystems.css';

const WeaponsPage = () => {
    return (
        <div className="subsystem-page">
            <h1>Weapons Subsystem</h1>
            <img src={weaponsImg} alt="Weapons" className="subsystem-image" />
            <p>
                The Weapons team is in charge of TONE’s most powerful feature — its spinning attack. This is what gives
                our robot its bite, sending opponents flying across the arena. We work to make sure the weapon is fast,
                reliable, and hits hard every time it spins up.
                <br/><br/>
                We constantly improve the design to make it stronger and more effective. It’s all about finding the
                perfect balance between speed and power, and making sure it delivers damage without slowing us down. Our
                goal is simple — strike first and strike hard.
            </p>
        </div>
    );
};

export default WeaponsPage;